module.exports = __webpack_public_path__ + "img/cy_16.png";